module.exports = __webpack_public_path__ + "static/media/business-samurai.c89da54d.png";